var map = {
	"./en.js": "FQqZ",
	"./index.js": "7J+P",
	"./zh.js": "hLMD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Cb1M";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang nonrecursive \.js$
// module id = Cb1M
// module chunks = 6 7